import { useEffect } from "react"
import { BrowserRouter, useLocation } from "react-router"
import { AppRoutes } from "./routes"
import { ErrorBoundary } from "@client/components/error-boundary"
import { MetaSync } from "@client/components/meta-sync"

function ScrollToTop() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" })
  }, [pathname, search])

  return null
}

export function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <MetaSync />
      <ErrorBoundary>
        <AppRoutes />
      </ErrorBoundary>
    </BrowserRouter>
  )
}
